import { render, staticRenderFns } from "./mahjongPhoenix.vue?vue&type=template&id=a80db1a6&scoped=true"
import script from "./mahjongPhoenix.vue?vue&type=script&lang=js"
export * from "./mahjongPhoenix.vue?vue&type=script&lang=js"
import style0 from "./mahjongPhoenix.vue?vue&type=style&index=0&id=a80db1a6&prod&scoped=true&lang=css"
import style1 from "./mahjongPhoenix.vue?vue&type=style&index=1&id=a80db1a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80db1a6",
  null
  
)

export default component.exports